var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 184,
    viewBox: "0 0 172 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.588 92H35.4111V178H136.588V92Z",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4115 92.0014L5.05859 61.6484",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.588 92.0014L166.941 61.6484",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1181 36.3516H80.9416L75.8828 41.4104V46.4692L80.9416 51.528H91.0593L96.1181 56.5869V61.6457L91.0593 66.7045H75.8828",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36.352V26.2344",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66.7031V76.8208",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0002 119.47C88.479 114.715 93.7402 111.578 99.659 112.337C106.438 113.197 111.294 119.217 111.294 126.046C111.294 133.382 108.36 140.413 103.2 145.624L86.0002 162.824L68.8002 145.624C63.5896 140.413 60.7061 133.382 60.7061 126.046C60.7061 118.863 66.1696 112.64 73.3531 112.236C78.8672 111.932 83.6731 114.967 86.0002 119.47Z",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1072 92C50.4872 84.4118 40.4707 69.1341 40.4707 51.5294C40.4707 26.3871 60.8578 6 86.0001 6C111.142 6 131.53 26.3871 131.53 51.5294C131.53 69.1341 121.513 84.4118 106.893 92",
    stroke: "#3F4D61",
    strokeWidth: 10.1176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.7034f47dd3cf7a714b11532bdaf881d0.svg";
export { ForwardRef as ReactComponent };